import { render, staticRenderFns } from "./AppSetting.vue?vue&type=template&id=6dc365f4&"
import script from "./AppSetting.vue?vue&type=script&lang=js&"
export * from "./AppSetting.vue?vue&type=script&lang=js&"
import style0 from "./AppSetting.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports